export const CONFIRMATIONS = 2;
export const TIMEOUT_MS = 180000; // 3 minutes
